import { render } from "./ViewProductcategory.vue?vue&type=template&id=6d45c252&scoped=true"
import script from "./ViewProductcategory.vue?vue&type=script&lang=js"
export * from "./ViewProductcategory.vue?vue&type=script&lang=js"

import "./ViewProductcategory.vue?vue&type=style&index=0&id=6d45c252&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d45c252"]])

export default __exports__